(function(){
  'use strict';

  /* Keep the original Harper custom JS, then apply only non-purchase repairs here. */
  try {
    var current = document.currentScript && document.currentScript.src;
    if (current) {
      var originalUrl = new URL(current, window.location.href);
      originalUrl.pathname = originalUrl.pathname.replace(/\/custom\.js$/, '/custom-original.js');
      var originalScript = document.createElement('script');
      originalScript.src = originalUrl.toString();
      originalScript.defer = true;
      document.head.appendChild(originalScript);
    }
  } catch (e) { console.warn('[Mavera] Original custom.js could not be loaded', e); }

  var CANONICAL_PATH = '/products/kedi-ve-kopekler-i%CC%87cin-led-isikli-pati-hassas-bolge-tiras-makinesi';
  var OLD_SINGLE = 'sarjli-pati-tiras-makinesi-tekli-paket';

  function normalizeOldLinks(){
    document.querySelectorAll('a[href]').forEach(function(a){
      var href = (a.getAttribute('href') || '').toLowerCase();
      if (href.indexOf(OLD_SINGLE) !== -1) a.setAttribute('href', CANONICAL_PATH);
    });
  }

  function fixHomepageCanonical(){
    if (location.pathname !== '/') return;
    var home = document.getElementById('mavera-home-final');
    if (!home) return;
    var hero = home.querySelector('.mv-hero-media');
    if (hero) hero.setAttribute('href', CANONICAL_PATH);
    home.querySelectorAll('a[href]').forEach(function(a){
      var href = (a.getAttribute('href') || '').toLowerCase();
      if (href.indexOf(OLD_SINGLE) !== -1 || href.indexOf('pati-hassas-bolge-tiras-makinesi') !== -1) {
        a.setAttribute('href', CANONICAL_PATH);
      }
    });
  }

  function cleanFakeScarcity(){
    document.querySelectorAll('#stock-number').forEach(function(el){
      el.removeAttribute('id');
      el.removeAttribute('data-order');
    });
    document.querySelectorAll('.announcement-bar__message, .announcement-bar p, [class*="announcement"] p').forEach(function(el){
      if ((el.textContent || '').trim() === 'Bu ürün hızla tükeniyor') {
        el.textContent = 'Ücretsiz kargo • Kapıda ödeme seçeneği • 14 gün cayma hakkı';
      }
    });
  }

  function run(){
    normalizeOldLinks();
    fixHomepageCanonical();
    cleanFakeScarcity();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run, {once:true});
  else run();
  window.setTimeout(run, 900);
})();
